module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": "",
      "id": "details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveDetails($event)
      }
    }
  }, [_c('v-container', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Hearing Information")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.postHearingLetterDialog = true
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("\n                            format_align_left\n                        ")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Post Hearing Letter")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.noteTaskDialog = true
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("assignment")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Notes & Tasks")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.contactDialog = true
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("person")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Contacts")])])], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "pa-0",
    attrs: {
      "id": "headerInfo"
    }
  }, [_c('v-container', {
    staticClass: "pa-2"
  }, [(_vm.hearingDetails) ? _c('v-form', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pr-1": "",
      "pb-0": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Hearing ID",
      "readonly": ""
    },
    model: {
      value: (_vm.id),
      callback: function($$v) {
        _vm.id = $$v
      },
      expression: "id"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": "",
      "pr-1": "",
      "pb-0": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.hearingDetails.editPolicyNumberFlag == 0,
      "label": "Policy #"
    },
    model: {
      value: (_vm.hearingDetails.policyNumber),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "policyNumber", $$v)
      },
      expression: "hearingDetails.policyNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": "",
      "pb-0": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.hearingDetails.editClaimNumberFlag == 0,
      "label": "BWC Claim #"
    },
    model: {
      value: (_vm.hearingDetails.claimNumber),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "claimNumber", $$v)
      },
      expression: "hearingDetails.claimNumber"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": !_vm.editable,
      "label": "Employer Name"
    },
    model: {
      value: (_vm.employerName),
      callback: function($$v) {
        _vm.employerName = $$v
      },
      expression: "employerName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "sm5": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.hearingDetails.editClaimantNameFirstFlag == 0,
      "label": "Claimant First Name"
    },
    model: {
      value: (_vm.hearingDetails.claimantNameFirst),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "claimantNameFirst", $$v)
      },
      expression: "hearingDetails.claimantNameFirst"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.hearingDetails.editClaimantNameMiddleFlag == 0,
      "label": "M.I."
    },
    model: {
      value: (_vm.hearingDetails.claimantNameMiddle),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "claimantNameMiddle", $$v)
      },
      expression: "hearingDetails.claimantNameMiddle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.hearingDetails.editClaimantNameLastFlag == 0,
      "label": "Claimant Last Name"
    },
    model: {
      value: (_vm.hearingDetails.claimantNameLast),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "claimantNameLast", $$v)
      },
      expression: "hearingDetails.claimantNameLast"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "mt-2",
    attrs: {
      "dense": "",
      "scroll-off-screen": "",
      "scroll-target": "#scrolling-tech"
    }
  }, [_c('v-toolbar-title', [_vm._v("Detail")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.editable) ? _c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.saveDetails
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("save")])], 1) : _vm._e()]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Save Details")])])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "scroll-y",
    staticStyle: {
      "max-height": "600px"
    },
    attrs: {
      "id": "scrolling-tech"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "pl-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "disabled": _vm.hearingDetails.editHearingDateTimeFlag == 0,
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    model: {
      value: (_vm.hearingDateMenu),
      callback: function($$v) {
        _vm.hearingDateMenu = $$v
      },
      expression: "hearingDateMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "disabled": _vm.hearingDetails.editHearingDateTimeFlag == 0,
      "value": _vm._f("formatDate")(_vm.hearingDetails.hearingDate),
      "label": "Hearing Date",
      "prepend-icon": "event"
    },
    on: {
      "input": function($event) {
        _vm.hearingDetails.hearingDate = $event.target.value
      }
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.hearingDateMenu = false
      }
    },
    model: {
      value: (_vm.hearingDetails.hearingDate),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "hearingDate", $$v)
      },
      expression: "hearingDetails.hearingDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "disabled": _vm.hearingDetails.editHearingDateTimeFlag == 0,
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.hearingDetails.hearingTime,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.hearingDetails, "hearingTime", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.hearingDetails, "hearingTime", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "value": _vm._f("formatTime")(_vm.hearingDetails.hearingTime),
            "label": "Time",
            "disabled": _vm.hearingDetails.editHearingDateTimeFlag == 0,
            "prepend-icon": "access_time"
          },
          on: {
            "input": function($event) {
              _vm.hearingDetails.hearingTime = $event.target.value
            }
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.hearingTimeMenu),
      callback: function($$v) {
        _vm.hearingTimeMenu = $$v
      },
      expression: "hearingTimeMenu"
    }
  }, [_vm._v(" "), (_vm.hearingTimeMenu) ? _c('v-time-picker', {
    attrs: {
      "full-width": ""
    },
    on: {
      "click:minute": function($event) {
        return _vm.$refs.menu.save(_vm.hearingDetails.hearingTime)
      }
    },
    model: {
      value: (_vm.hearingDetails.hearingTime),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "hearingTime", $$v)
      },
      expression: "hearingDetails.hearingTime"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm2": "",
      "md1": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:50'),
      expression: "'max:50'"
    }],
    staticClass: "purple-input",
    attrs: {
      "label": "Room",
      "disabled": _vm.hearingDetails.editRoomFlag == 0,
      "name": "room",
      "error-messages": _vm.errors.collect('room')
    },
    model: {
      value: (_vm.hearingDetails.room),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "room", $$v)
      },
      expression: "hearingDetails.room"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.hearingReps,
      "label": "Hearing Rep",
      "disabled": _vm.hearingDetails.editRepIDFlag == 0,
      "item-text": "description",
      "item-value": "id"
    },
    model: {
      value: (_vm.hearingDetails.hearingRep),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "hearingRep", $$v)
      },
      expression: "hearingDetails.hearingRep"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.issues,
      "label": "Hearing Issue",
      "disabled": _vm.hearingDetails.editfkHearingIssueFlag == 0,
      "item-text": "description",
      "item-value": "id"
    },
    model: {
      value: (_vm.hearingDetails.fkHearingIssue),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "fkHearingIssue", $$v)
      },
      expression: "hearingDetails.fkHearingIssue"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.cities,
      "label": "City",
      "disabled": !_vm.editable,
      "item-text": "description",
      "item-value": "id"
    },
    model: {
      value: (_vm.hearingDetails.fkHearingDemographics),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "fkHearingDemographics", $$v)
      },
      expression: "hearingDetails.fkHearingDemographics"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:50'),
      expression: "'max:50'"
    }],
    staticClass: "purple-input",
    attrs: {
      "label": "Room",
      "disabled": _vm.hearingDetails.editRoomFlag == 0,
      "name": "room",
      "error-messages": _vm.errors.collect('room')
    },
    model: {
      value: (_vm.hearingDetails.room),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "room", $$v)
      },
      expression: "hearingDetails.room"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }],
    staticClass: "purple-input",
    attrs: {
      "label": "Rep ID",
      "disabled": _vm.hearingDetails.editRepIDFlag == 0,
      "name": "repID",
      "error-messages": _vm.errors.collect('repID')
    },
    model: {
      value: (_vm.hearingDetails.repID),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "repID", $$v)
      },
      expression: "hearingDetails.repID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.comments,
      "label": "Comments",
      "disabled": _vm.hearingDetails.editPendedCommentsFlag == 0,
      "item-text": "description",
      "item-value": "id"
    },
    model: {
      value: (_vm.hearingDetails.fkHearingComment),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "fkHearingComment", $$v)
      },
      expression: "hearingDetails.fkHearingComment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.docketTypes,
      "label": "Docket Type",
      "item-text": "description",
      "item-value": "id",
      "disabled": _vm.hearingDetails.editfkDocketFlag == 0
    },
    model: {
      value: (_vm.hearingDetails.fkDocket),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "fkDocket", $$v)
      },
      expression: "hearingDetails.fkDocket"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.hearingLevels,
      "label": "Hearing Level",
      "item-text": "description",
      "item-value": "id",
      "disabled": _vm.hearingDetails.editfkHearingLevelFlag == 0
    },
    model: {
      value: (_vm.hearingDetails.fkHearingLevel),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "fkHearingLevel", $$v)
      },
      expression: "hearingDetails.fkHearingLevel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.hearingOfficers,
      "label": "Hearing Officer",
      "item-text": "description",
      "item-value": "id",
      "disabled": _vm.hearingDetails.editfkHearingOfficerFlag == 0
    },
    model: {
      value: (_vm.hearingDetails.fkHearingOfficer),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "fkHearingOfficer", $$v)
      },
      expression: "hearingDetails.fkHearingOfficer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "MCO",
      "readonly": ""
    },
    model: {
      value: (_vm.hearingDetails.mco),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "mco", $$v)
      },
      expression: "hearingDetails.mco"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.attorneyOptions,
      "item-text": "description",
      "item-value": "id",
      "disabled": _vm.hearingDetails.editfkHearingAttorneyFlag == 0,
      "label": "Attorney"
    },
    model: {
      value: (_vm.hearingDetails.fkHearingAttorney),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "fkHearingAttorney", $$v)
      },
      expression: "hearingDetails.fkHearingAttorney"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.outcomeOptions,
      "item-text": "description",
      "item-value": "id",
      "disabled": _vm.hearingDetails.editfkHearingOutcomeFlag == 0,
      "label": "Hearing Outcome"
    },
    model: {
      value: (_vm.hearingDetails.fkHearingOutcome),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "fkHearingOutcome", $$v)
      },
      expression: "hearingDetails.fkHearingOutcome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.pendedReasons,
      "disabled": _vm.hearingDetails.editPendedReasonsFlag == 0,
      "item-text": "description",
      "item-value": "id",
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "label": "Pended Reason"
    },
    model: {
      value: (_vm.hearingDetails.pendedReasons),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "pendedReasons", $$v)
      },
      expression: "hearingDetails.pendedReasons"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Prep Complete",
      "disabled": _vm.hearingDetails.editPrepCompletedFlag == 0
    },
    on: {
      "change": _vm.checkPrep
    },
    model: {
      value: (_vm.hearingDetails.prepCompleted),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "prepCompleted", $$v)
      },
      expression: "hearingDetails.prepCompleted"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:400'),
      expression: "'max:400'"
    }],
    staticClass: "purple-input",
    attrs: {
      "label": "Pended Comments",
      "disabled": _vm.hearingDetails.editPendedCommentsFlag == 0,
      "auto-grow": "",
      "counter": 400,
      "name": "pendedComments",
      "error-messages": _vm.errors.collect('pendedComments')
    },
    model: {
      value: (_vm.hearingDetails.pendedComments),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "pendedComments", $$v)
      },
      expression: "hearingDetails.pendedComments"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:1024'),
      expression: "'max:1024'"
    }],
    staticClass: "purple-input",
    attrs: {
      "disabled": _vm.hearingDetails.editSpecialInstructionsFlag == 0,
      "label": "Hearing Special Instructions",
      "value": "",
      "counter": 1024,
      "auto-grow": "",
      "name": "specialInstructions",
      "error-messages": _vm.errors.collect('specialInstructions')
    },
    model: {
      value: (_vm.hearingDetails.specialInstructions),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "specialInstructions", $$v)
      },
      expression: "hearingDetails.specialInstructions"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-textarea', {
    staticClass: "purple-input",
    attrs: {
      "disabled": _vm.hearingDetails.editEmployerSpecialInstructionsFlag == 0,
      "label": "Employer Special Instructions",
      "value": "",
      "auto-grow": ""
    },
    model: {
      value: (_vm.hearingDetails.employerSpecialInstructions),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "employerSpecialInstructions", $$v)
      },
      expression: "hearingDetails.employerSpecialInstructions"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-textarea', {
    staticClass: "purple-input",
    attrs: {
      "disabled": 0,
      "label": "Hearing Issues",
      "value": "",
      "auto-grow": ""
    },
    model: {
      value: (_vm.hearingDetails.hearingIssues),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "hearingIssues", $$v)
      },
      expression: "hearingDetails.hearingIssues"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-toolbar', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.editable) ? _c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.saveDetails
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("save")])], 1) : _vm._e()]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Save Details")])])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.postHearingLetterDialog),
      callback: function($$v) {
        _vm.postHearingLetterDialog = $$v
      },
      expression: "postHearingLetterDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "blue-grey"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.postHearingLetterDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Post Hearing Letter")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": "",
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Policy #"
    },
    model: {
      value: (_vm.hearingDetails.policyNumber),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "policyNumber", $$v)
      },
      expression: "hearingDetails.policyNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": "",
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "BWC Claim #"
    },
    model: {
      value: (_vm.hearingDetails.claimNumber),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "claimNumber", $$v)
      },
      expression: "hearingDetails.claimNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "lg8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Employer Name"
    },
    model: {
      value: (_vm.hearingDetails.employerName),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "employerName", $$v)
      },
      expression: "hearingDetails.employerName"
    }
  })], 1)], 1), _vm._v(" "), (_vm.hearingDetails.pkHearing) ? _c('post-hearing-letter', {
    attrs: {
      "hearingDetails": _vm.hearingDetails
    },
    on: {
      "closePostDialog": function($event) {
        _vm.postHearingLetterDialog = false
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.noteTaskDialog),
      callback: function($$v) {
        _vm.noteTaskDialog = $$v
      },
      expression: "noteTaskDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "blue-grey"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.noteTaskDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Notes & Tasks " + _vm._s(_vm.displayName))])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": "",
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Policy #"
    },
    model: {
      value: (_vm.hearingDetails.policyNumber),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "policyNumber", $$v)
      },
      expression: "hearingDetails.policyNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": "",
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "BWC Claim #"
    },
    model: {
      value: (_vm.hearingDetails.claimNumber),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "claimNumber", $$v)
      },
      expression: "hearingDetails.claimNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "lg8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Employer Name"
    },
    model: {
      value: (_vm.hearingDetails.employerName),
      callback: function($$v) {
        _vm.$set(_vm.hearingDetails, "employerName", $$v)
      },
      expression: "hearingDetails.employerName"
    }
  })], 1)], 1), _vm._v(" "), (_vm.hearingDetails.pkHearing) ? _c('note-task-list', {
    attrs: {
      "grid": _vm.notesAndTasks,
      "hearingDetails": _vm.hearingDetails
    },
    on: {
      "refreshData": _vm.loadNotesAndTasks,
      "toggleAll": _vm.toggleAll
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.contactDialog),
      callback: function($$v) {
        _vm.contactDialog = $$v
      },
      expression: "contactDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "blue-grey"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.contactDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Contacts " + _vm._s(_vm.displayName))]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [(_vm.hearingDetails.policyNumber) ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('grid', {
    attrs: {
      "gridTitle": "Internal Contacts"
    },
    model: {
      value: (_vm.contactsData.internalContacts),
      callback: function($$v) {
        _vm.$set(_vm.contactsData, "internalContacts", $$v)
      },
      expression: "contactsData.internalContacts"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('grid', {
    attrs: {
      "gridTitle": "Employer Contacts"
    },
    model: {
      value: (_vm.contactsData.employerContacts),
      callback: function($$v) {
        _vm.$set(_vm.contactsData, "employerContacts", $$v)
      },
      expression: "contactsData.employerContacts"
    }
  })], 1)] : [_vm._v("\n                        Unable to load contacts without a policy number. Please provide a policy number for the Hearing to view associated contact information.\n                    ")]], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1422a152", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1422a152"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/portalhome/docketing/pages/hearingdetails/detailsform/detailsform.vue.html
// module id = 581
// module chunks = 0